
import Tab from './tab';
import TabListProps from './mixins/TabListProps';
import { TabListEventType, TabListProperty, TabProperty } from './enums';

export default {
  name: 'TabList',
  components: {
    Tab,
  },
  mixins: [TabListProps],
  data() {
    return {
      TabListEventType,
      TabListProperty,
      TabProperty,
    };
  },
  computed: {
    currentActiveIndex() {
      return this[TabListProperty.ActiveIndex];
    },
  },
  methods: {
    handleTabChange(index) {
      this.$emit(TabListEventType.TabChange, index);
    },
  },
};
